<script lang="ts">
  import { toasts, type ToastTone } from "./toast.svelte";

  const accent: Record<ToastTone, string> = {
    ok: "border-l-ok",
    warn: "border-l-warn",
    down: "border-l-down",
    info: "border-l-info",
  };
</script>

<div
  class="pointer-events-none fixed bottom-4 right-4 z-50 flex w-[min(92vw,22rem)] flex-col gap-2"
  aria-live="polite"
>
  {#each toasts.items as t (t.id)}
    <div
      class={`rise pointer-events-auto flex items-start gap-3 rounded-lg border border-line border-l-4 bg-overlay px-4 py-3 text-sm text-ink shadow-xl shadow-black/40 ${accent[t.tone]}`}
    >
      <span class="min-w-0 flex-1 break-words">{t.message}</span>
      <button
        class="shrink-0 text-ink-faint hover:text-ink"
        aria-label="Dismiss"
        onclick={() => toasts.dismiss(t.id)}
      >
        ✕
      </button>
    </div>
  {/each}
</div>
